export const EXPERIMENT_ID =
    window.location.hostname === 'giphy.com' ? 'VTuZsxBSQnqR3PhX37HR9w' : 'KW3Xp0MLSh-21cb-GX5ONw'
